'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDestinationProductSelect = function () {
    function WinresDestinationProductSelect($scope, $filter, productService, localizationService, urlService) {
        _classCallCheck(this, WinresDestinationProductSelect);

        this.$scope = $scope;
        this.$filter = $filter;
        this.productService = productService;
        this.localizationService = localizationService;
        this.urlService = urlService;
        this.destinationProduct = null;
    }

    _createClass(WinresDestinationProductSelect, [{
        key: '$onInit',
        value: function $onInit() {
            this.data = this.winresReservationContext.getContext();
            this.fetchDestinationProducts();
        }
    }, {
        key: 'fetchDestinationProducts',
        value: function fetchDestinationProducts() {
            console.log('[WinresDestinationProductSelect]', 'This feature is not supported by this version.');
            // const urlParams = this.winresReservationContext.getUrlParams();

            // this.productService.getDestinationProducts(urlParams.DestinationCode, this.localizationService.getLanguage()).then(destinationProducts => {
            //     this.destinationProducts = destinationProducts;

            //     // Default option for select.
            //     this.selectDefaultDestinationProduct(urlParams.ProductCode);
            // });
        }
    }, {
        key: 'selectDefaultDestinationProduct',
        value: function selectDefaultDestinationProduct(productCode) {
            if (!productCode) {
                // Select first.
                this.destinationProduct = this.destinationProducts[0];
            } else {
                // Product in url.
                this.destinationProduct = _.find(this.destinationProducts, function (destinationProduct) {
                    return destinationProduct.ProductCode === productCode;
                });
            }
        }
    }, {
        key: 'onDestinationProductChange',
        value: function onDestinationProductChange() {
            if (this.destinationProduct) {
                this.winresReservationContext.$scope.productCode = this.destinationProduct.ProductCode;

                // Change destination for reservation components.
                this.changeDestination();

                // Add product code to url.
                this.addProductCodeToUrl();
            }
        }
    }, {
        key: 'changeDestination',
        value: function changeDestination() {
            // Update data for destination.
            this.winresReservationContext.initUrlData();
            this.winresReservationContext.initPassengerFieldsBase();
            this.winresReservationContext.initPassengers();

            // Reset loading destination for full refresh.
            this.winresReservationContext.loadingDestination = null;

            // Load the actual destination.
            this.winresReservationContext.loadDestination();
        }
    }, {
        key: 'addProductCodeToUrl',
        value: function addProductCodeToUrl() {
            var urlParams = this.winresReservationContext.getUrlParams();

            // Update url with product code.
            this.urlService.setParamsToUrl({
                dn: urlParams.DestinationName,
                dc: urlParams.DestinationCode,
                pc: urlParams.ProductCode,
                bd: urlParams.StartDate,
                ed: urlParams.EndDate,
                na: urlParams.NumAdults,
                nc: urlParams.NumChildren,
                ni: urlParams.NumInfants
            }, false);
        }
    }]);

    return WinresDestinationProductSelect;
}();

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl(getWebcomponentsUrl($attrs.templateUrl)) : 'DestinationProductSelect';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('DestinationProductSelect', require('./winresDestinationProductSelect.html'));
}]);

WinresDestinationProductSelect.$inject = ['$scope', '$filter', 'productService', 'localizationService', 'urlService'];

_module3.default.component('winresDestinationProductSelect', {
    templateUrl: getTemplate,
    controller: WinresDestinationProductSelect,
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestinationProductSelect/winresDestinationProductSelect.js
// module id = 517
// module chunks = 2